import SpanDetails from "./SpanDetails";
import type { TraceDetailState } from "./hooks/useTraceDetailState";

import WorkflowCanvas from "@/components/Workflows/WorkflowCanvas";

interface TraceSpanDetailsPanelProps {
  isLoading: TraceDetailState["isLoading"];
  isWorkflow: TraceDetailState["isWorkflow"];
  selectedSpan: TraceDetailState["selectedSpan"];
  traceInput: TraceDetailState["traceInput"];
  traceFinalOutput: TraceDetailState["traceFinalOutput"];
  traceEntities: TraceDetailState["traceEntities"];
  traceRunning?: boolean;
  onJumpToSpan: (spanId: string) => void;
  userToken: TraceDetailState["userToken"];
  workflow: TraceDetailState["workflow"];
}

const TraceSpanDetailsPanel = ({
  isLoading,
  isWorkflow,
  selectedSpan,
  traceInput,
  traceFinalOutput,
  traceEntities,
  traceRunning = false,
  onJumpToSpan,
  userToken,
  workflow,
}: TraceSpanDetailsPanelProps) => (
  <div className="flex h-full flex-col overflow-hidden p-6">
    {isWorkflow && workflow && (
      <div
        className={`mb-5 flex h-60 w-full flex-shrink-0 transition-opacity duration-200 ease-in-out ${
          isLoading ? "opacity-25" : ""
        }`}
      >
        <WorkflowCanvas embed readonly {...workflow} userToken={userToken} />
      </div>
    )}
    <div className="flex-1 overflow-auto">
      <SpanDetails
        selectedSpan={selectedSpan}
        traceInput={traceInput}
        traceFinalOutput={traceFinalOutput}
        traceEntities={traceEntities}
        traceRunning={traceRunning}
        onJumpToSpan={onJumpToSpan}
      />
    </div>
  </div>
);

export default TraceSpanDetailsPanel;
